import { MouseProjectionEnum } from '../enums/mouse-projection-enum';

/**
 * Representa un sistema de referencia espacial (SRS) usado por la aplicación.
 * Agrupa la proyección normalizada, el WKID EPSG, su etiqueta y código.
 */
export class SpatialReferenceEntity {
  wkid!: number;
  projection?: MouseProjectionEnum;
  label?: string;
  code?: string;

  constructor(init: Partial<SpatialReferenceEntity> = {}) {
    Object.assign(this, init);
  }
}